<p-card header="Create Incident">
  <app-incident-form (submit)="createIncident($event)"></app-incident-form>
</p-card>
